module.exports = __webpack_public_path__ + "static/trusted-logos-13cd119db4b44afa59313e40c1af001e.png";